var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Day',{attrs:{"day":"09.12.2023"}},[_c('div',{attrs:{"slot":"page-content"},slot:"page-content"},[_c('h1',{staticClass:"headline mb-5 align-center px-5"},[_vm._v(" Mondd \"ÁÁÁ\"! ")]),_c('p',{staticClass:"px-5"},[_vm._v(" Ma reggelre új nap virradt, tán, már a popsid sem sajog. Ülj le hát, nyisd ki szád, és nyeld, amit eléd rakok. ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }